// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"CI-z","hovered":"DI-z","hoverImage":"EI-z","mainImage":"FI-z","imageNoBackground":"GI-z","fullSizeImage":"HI-z"};